import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export const state = {
  google: {
    api: null,
    auth: null,
    management: null
  },
  auth: {
    listener: false,
    signedIn: false,
    response: null,
    user: null,
    profile: {},
    params: ""
  },
  notifications: [],
  breadcrumbs: [],
  navigation: {
    account: null,
    webProperty: null,
    profile: null
  }
};

export const getters = {
  isLoggedIn: state => {
    return state.auth.signedIn;
  }
};

let nextId = 1; // for notification keys

export const mutations = {
  SET_NAVIGATION(state, navigation) {
    state.navigation = navigation;
  },
  SET_BREADCRUMBS(state, breadcrumbs) {
    state.breadcrumbs = breadcrumbs;
  },
  SET_GOOGLE_API(state, gapi) {
    state.google.api = gapi;
  },
  SET_GOOGLE_AUTH(state, GoogleAuth) {
    state.google.auth = GoogleAuth;
  },
  SET_GOOGLE_MANAGEMENT(state, GoogleManagement) {
    state.google.management = GoogleManagement;
  },
  SET_AUTH_LISTENER(state, status) {
    state.auth.listener = status;
  },
  SIGN_OUT(state) {
    state.auth.signedIn = false;
    state.auth.profile = {};
    state.auth.response = null;
    state.auth.user = null;
    state.auth.params = null;
  },
  SET_SIGN_IN_STATUS(state, status) {
    state.auth.signedIn = status;
  },
  SET_USER(state, { user, profile }) {
    state.auth.profile = profile;
    state.auth.user = user;
  },
  SET_AUTH_RESPONSE(state, authResponse) {
    state.auth.response = authResponse;
    state.auth.params = `?access_token=${authResponse.access_token}&id_token=${
      authResponse.id_token
    }`;
  },
  PUSH_NOTIFICATION(state, notification) {
    state.notifications.push({
      ...notification
    });
  },
  DELETE_NOTIFICATION(state, notificationToRemove) {
    state.notifications = state.notifications.filter(
      notification => notification.id !== notificationToRemove.id
    );
  }
};

export const actions = {
  setGoogleAuth({ commit }, GoogleAuth) {
    commit("SET_GOOGLE_AUTH", GoogleAuth);
  },
  setGoogleApi({ commit }, gapi) {
    commit("SET_GOOGLE_API", gapi);
  },
  setGoogleManagement({ commit }, GoogleManagement) {
    commit("SET_GOOGLE_MANAGEMENT", GoogleManagement);
  },
  checkSignInStatus({ state, commit, dispatch }) {
    const GoogleAuth = state.google.auth;

    // get the sign in status from the auth object
    const isSignedIn = GoogleAuth.isSignedIn.get();

    if (state.auth.signedIn !== isSignedIn) {
      commit("SET_SIGN_IN_STATUS", isSignedIn);
    }

    // listen for sign-in state changes, if one occurs reevaluate state
    if (!state.auth.listener) {
      GoogleAuth.isSignedIn.listen(() => {
        store.dispatch("checkSignInStatus");
      });

      commit("SET_AUTH_LISTENER", true);
    }

    // checks if the user is signed in.
    // if the user is signed in fetch the profile information
    if (isSignedIn) {
      dispatch("fetchProfile");
    } else if (state.auth.isSignedIn && !isSignedIn) {
      commit("SIGN_OUT");
    }
  },
  signIn({ state, dispatch }) {
    const GoogleAuth = state.google.auth;

    // this calls the sign in window with the account select screen
    // this makes it easier to toggle between accounts instead of
    // doing an automatic sign in to the default account
    GoogleAuth.signIn({
      prompt: "select_account",
      ux_mode: "popup"
    })
      // if the user successfully sign in fetch profile info
      .then(res => dispatch("fetchProfile"))
      // if the user gets an error sign out
      .catch(err => {
        let notification = {
          type: "error",
          message: err.message
        };

        this.$store.dispatch("addNotification", notification);
        dispatch("SIGN_OUT");
      });
  },
  signOut({ commit }) {
    const GoogleAuth = state.google.auth;
    GoogleAuth.signOut();

    commit("SET_SIGN_IN_STATUS", false);
    commit("SIGN_OUT");
  },
  fetchProfile({ commit, state, getters }) {
    getters.getGoogl;
    const GoogleAuth = state.google.auth;
    const user = GoogleAuth.currentUser.get();
    const authResponse = user.getAuthResponse();
    const basicProfile = user.getBasicProfile();
    const profile = {
      name: basicProfile.getName(),
      email: basicProfile.getEmail(),
      image: basicProfile.getImageUrl()
    };

    commit("SET_USER", {
      user,
      profile
    });
    commit("SET_AUTH_RESPONSE", authResponse);
  },
  addNotification({ commit }, notification) {
    notification = {
      ...notification,
      id: nextId++
    };

    commit("PUSH_NOTIFICATION", notification);

    setTimeout(() => {
      commit("DELETE_NOTIFICATION", notification);
    }, 3 * 1000);
  },
  deleteNotification({ commit }, notificationToRemove) {
    commit("DELETE_NOTIFICATION", notificationToRemove);
  },
  setNavigation({ commit }, { account, webProperty, profile }) {
    commit("SET_NAVIGATION", {
      account,
      webProperty,
      profile
    });

    let breadcrumbs = [
      {
        text: "Home",
        disabed: false,
        href: "/"
      }
    ];

    if (account) {
      breadcrumbs.push({
        text: `Account (${account})`,
        disabed: false,
        href: `/accounts/${account}`
      });
    }

    if (webProperty) {
      breadcrumbs.push({
        text: `Webproperty (${webProperty})`,
        disabed: false,
        href: `/accounts/${account}/properties/${webProperty}`
      });
    }

    if (profile) {
      breadcrumbs.push({
        text: `Profile (${profile})`,
        disabed: true,
        href: `/accounts/${account}/properties/${webProperty}/profiles/${profile}`
      });
    }

    commit("SET_BREADCRUMBS", breadcrumbs);
  }
};

export const store = new Vuex.Store({
  getters,
  mutations,
  actions,
  state
});
